import React, { Component, createRef } from "react";
import { isBrowser, isMobile } from "react-device-detect";
import { connect } from "react-redux";
import Div100vh from "react-div-100vh";
import { Alert, notification } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import AvatarAI from "./avatarAI";
import Speech from "./speech";
import {
	removeStorageWhenLogout,
	setHtmlStorage,
	statusHtmlStorage,
} from "../../config/helper";
import Profile from "../../components/profile";
import * as actionHome from "../../store/home/action";
import * as actionAuth from "../../store/auth/action";
import * as actionSending from "../../store/sending/action";
import config from "../../config";
import FetchApi from "../../services/api";
import serviceHome from "../../services/home";
import "./home.css";
import ChatList from "./chatList";

class Home extends Component {
	constructor(props) {
		super(props);
		this.avatarCache = localStorage.getItem("dataAvatar")
			? JSON.parse(localStorage.getItem("dataAvatar"))
			: {};
		this.muteState = localStorage.getItem("muteState");
		this.elementRef = createRef();
		this.scrollRef = createRef();
		this.state = {
			chatMessage: "",
			sendLoading: false,
			chatLoading: false,
			listChat: [],
			listChatPage: 0,
			swapAvatar: false,
			loadPrev: false,
			blockedApps: {
				state: false,
				message: "",
			},
		};
	}

	componentDidMount() {
		if (!statusHtmlStorage("accessToken")) {
			removeStorageWhenLogout();
			window.location.href = "/signin";
		}
		this.getHistoryChat();
		// setInterval(() => {
		//   this.authRefreshToken();
		// }, 30000);
		this.elementRef.current.addEventListener("scroll", this.handleScroll);
	}

	componentWillUnmount() {
		this.elementRef.current.removeEventListener(
			"scroll",
			this.handleScroll
		);
	}

	componentDidUpdate() {
		if (!this.state.loadPrev) {
			this.scrollToBottom();
		}
	}

	authRefreshToken = async () => {
		const response = await FetchApi(
			`${config.urls.apiBaseUrl}api/Account/refreshToken`,
			"POST"
		);
		if (response.httpStatus === 200) {
			setHtmlStorage("accessToken", response.data.token);
		}
		if (response.httpStatus === 401) {
			removeStorageWhenLogout();
			window.location.href = "/signin";
		}
	};

	getHistoryChat = async (pageNumber = 0) => {
		const response = await serviceHome.historyChat(pageNumber);

		if (response.httpStatus === 200) {
			const loadedChat =
				response.data?.data?.length > 0 ? response.data?.data : [];

			// let newHistoryChat = [
			// 	{
			// 		answer: localStorage.getItem("AIGreet"),
			// 		createdDate: localStorage.getItem("accessDate"),
			// 		question: "",
			// 	},
			// ];
			// if (loadedChat.length > 0) {
			// 	newHistoryChat = [...loadedChat, ...newHistoryChat];
			// }

			this.setState({
				listChat: loadedChat,
				listChatPage: response.data?.pageNumber,
			});
		}
		if (response.httpStatus === 500) {
			notification.error({
				message: "Something wrong please try again in few minutes.",
			});
		}
	};

	handleSendButton = async (text) => {
		if (text.trim() === "") return;

		this.setState({ sendLoading: true, loadPrev: false });
		const payload = {
			data: JSON.stringify({
				text: text,
				personality: this.props.profile.data.aIpersonality,
				isConversationStart: true,
			}),
		};

		let newChatList = [];
		if (this.state.listChat.length > 0) {
			newChatList = [
				...this.state.listChat,
				{
					answer: null,
					createdDate: dayjs().toISOString(),
					question: text,
				},
			];
		}
		this.setState({ listChat: newChatList });

		const sendingTextResponse = await FetchApi(
			`${config.urls.apiBaseUrl}api/GPT/TextChat`,
			"POST",
			payload
		);

		if (sendingTextResponse.httpStatus === 200) {
			newChatList[newChatList.length - 1].answer =
				sendingTextResponse.data.content;
			this.handleSpeak(sendingTextResponse.data.content);
		}
		if (sendingTextResponse.httpStatus === 500) {
			newChatList[newChatList.length - 1].answer =
				"Oops something wrong, please try again in few minutes.";
		}
		if (sendingTextResponse.httpStatus === 400) {
			newChatList[newChatList.length - 1].answer =
				"Invalid user input, please send correct input.";
		}
		if (sendingTextResponse.httpStatus === 401) {
			newChatList[newChatList.length - 1].answer = "Unauthorize.";
			removeStorageWhenLogout();
			setTimeout(() => {
				window.location.href = "/signin";
			}, 3000);
		}
		this.setState({
			listChat: newChatList,
			chatMessage: "",
			sendLoading: false,
		});
	};

	scrollToBottom = () => {
		this.scrollRef.current?.scrollIntoView({ behavior: "smooth" });
	};

	handleSpeak = (text) => {
		if (isMobile || this.muteState === "true") return;

		if ("speechSynthesis" in window) {
			const synthesis = window.speechSynthesis;
			const utterance = new SpeechSynthesisUtterance(text);

			const avatarGender = this.avatarCache.aIsrc
				.replace("/static/media/", "")
				.split(".")[0];

			const voiceGender = synthesis.getVoices().find((voice) => {
				const isFemale = ["woman-1", "woman-2", "woman-3"].includes(
					avatarGender
				);
				return isFemale
					? ["Female", "Victoria", "Aria", "Zira"].some((name) =>
							voice.name.includes(name)
					  )
					: ["Male", "David", "Mark"].some((name) =>
							voice.name.includes(name)
					  );
			});
			utterance.voice = voiceGender;
			setTimeout(() => synthesis.speak(utterance), 1000);
		} else {
			this.setState({
				blockedApps: {
					state: true,
					message:
						"Speech synthesis is not supported in this browser.",
				},
			});
			console.error("Speech synthesis is not supported in this browser.");
		}
	};

	handleScroll = async () => {
		const element = this.elementRef.current;
		if (element.scrollTop === 0) {
			this.setState({ chatLoading: true, loadPrev: true });
			const response = await serviceHome.historyChat(
				this.state.listChatPage + 1
			);
			if (response.httpStatus === 200) {
				const loadedChat =
					response.data?.data?.length > 0 ? response.data?.data : [];

				const newHistoryChat = [...loadedChat, ...this.state.listChat];

				if (loadedChat.length > 0) {
					this.setState({
						listChat: newHistoryChat,
						listChatPage: response.data?.pageNumber,
					});
				}
				this.setState({
					chatLoading: false,
				});
			}
			if (response.httpStatus === 500) {
				notification.error({
					message: "Something wrong please try again in few minutes.",
				});
				this.setState({ chatLoading: false, loadPrev: false });
			}
		}
	};

	handleSortChatByDate = (listChat) => {
		let newArrList = [];
		for (let i = 0; i < listChat.length; i++) {
			const chat = listChat[i];
			const createdDate = dayjs(chat.createdDate).format("DD/MM/YYYY");
			const isExist = newArrList.find(
				(item) => item.createdDate === createdDate
			);

			if (!isExist) {
				newArrList.push({ createdDate: createdDate });
			}
		}

		for (let j = 0; j < newArrList.length; j++) {
			const chat = newArrList[j];
			const newArr = [];
			for (let k = 0; k < listChat.length; k++) {
				const element = listChat[k];
				if (
					chat.createdDate ===
					dayjs(element.createdDate).format("DD/MM/YYYY")
				) {
					newArr.push(element);
				}
			}
			newArrList[j].chat = newArr.sort(
				(a, b) => new Date(a.createdDate) - new Date(b.createdDate)
			);
		}

		newArrList = newArrList.sort(
			(a, b) => new Date(a.createdDate) - new Date(b.createdDate)
		);

		return newArrList;
	};

	render() {
		return (
			<Div100vh className="homepage">
				<div
					className={`home-wrapper${
						this.state.blockedApps.state || isMobile
							? " blocked-apps"
							: ""
					}`}
				>
					<Profile
						openSwitchAvatar={this.state.swapAvatar}
						onChangeSwitchAvatar={(value) =>
							this.setState({ swapAvatar: value })
						}
					/>
					{isBrowser && this.state.blockedApps.state && (
						<Alert
							message={this.state.blockedApps.message}
							type="error"
						/>
					)}
					{/* {isMobile && (
						<Alert
						message="Your browser does not support some of features! Please use chrome desktop browser for best experience."
						type="error"
						/>
					)} */}
					<div
						className={`user-conversation${
							this.props.micOpen ? " user-mic-open" : ""
						}`}
					>
						<AvatarAI
							swapAvatar={(value) =>
								this.setState({ swapAvatar: value })
							}
						/>
						<div className="user-conversation-wrapper">
							<div
								style={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									margin: "0 0 5px",
									width: "100%",
									opacity: this.state.chatLoading ? 1 : 0,
								}}
							>
								<LoadingOutlined />
							</div>
							<div
								ref={this.elementRef}
								style={{
									width: "100%",
									overflow: "overlay",
									paddingRight: 5,
								}}
							>
								{this.handleSortChatByDate(
									this.state.listChat
								).map((chat, key) => {
									return (
										<ChatList
											key={key}
											chat={chat}
											response={this.props.textResponse}
											version="1"
										/>
									);
								})}
								<div
									ref={this.scrollRef}
									style={{ float: "left", clear: "both" }}
								/>
							</div>
						</div>
					</div>
					<Speech
						sendLoading={this.state.sendLoading}
						onSend={(text) => this.handleSendButton(text)}
						onBlocked={(state, message) =>
							this.setState({
								blockedApps: {
									state,
									message,
								},
							})
						}
					/>
				</div>
			</Div100vh>
		);
	}
}

const stateToProps = (state) => {
	const { auth, home, profile, sending } = state;
	return {
		loading: home.loading,
		micOpen: home.micOpen,
		historyChat: home.historyChat,
		refreshResponse: auth.refreshResponse,
		sendLoading: sending.loading,
		textResponse: sending.textResponse,
		question: sending.question,
		profile: profile.profile,
	};
};

const dispatchToProps = (dispatch) => ({
	authRefresh: () => dispatch(actionAuth.authRefresh()),
	setMicOpen: (payload) => dispatch(actionHome.setMicOpen(payload)),
	getHistoryChat: (pageNumber = "") =>
		dispatch(actionHome.historyChat(pageNumber)),
	sendText: (payload) => dispatch(actionSending.sendText(payload)),
	setSendLoading: (payload) => dispatch(actionSending.setLoading(payload)),
});

export default connect(stateToProps, dispatchToProps)(Home);
